import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ProductGrid } from "../components/ProductGrid";
import { PRODUCT_CATEGORIES } from "../types";
import type { ProductWithImages } from "../types";
import { usePageTitle } from "../hooks/usePageTitle";

export function ProductList() {
  const { category } = useParams();
  const [products, setProducts] = useState<ProductWithImages[]>([]);
  const [loading, setLoading] = useState(true);

  const categoryLabel =
    PRODUCT_CATEGORIES.find((c) => c.value === category)?.label || "All Products";

  usePageTitle(categoryLabel);

  useEffect(() => {
    fetchProducts();
  }, [category]);

  const fetchProducts = async () => {
    try {
      const url = category
        ? `/api/products?category=${category}`
        : "/api/products";
      const response = await fetch(url);
      if (response.ok) {
        const data = await response.json();
        setProducts(data);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <nav className="text-sm text-gray-600 mb-4">
        <a href="/" className="hover:underline">
          Home
        </a>{" "}
        / {categoryLabel}
      </nav>

      <h1 className="text-4xl font-bold mb-8">{categoryLabel}</h1>

      <ProductGrid products={products} loading={loading} />
    </div>
  );
}
